import React from 'react'
import { Helmet } from 'react-helmet'
import banner from '../../images/banners/sameday.jpg'

export default function Sameday_service() {
  return (
    <div>
      <Helmet>
        <title>Shypv | Same Day Delivery</title>
      </Helmet>
      <section className="your_business_page fw" style={{ backgroundImage: `url(${banner})`, backgroundAttachment: 'fixed', backgroundSize: 'cover' }}>
        <div className="container"><div className="row">
          <div className="col-md-12 col-sm-12 your_business text-center">
            <div className="business_content">
              <h1 className="mainhead">SAME DAY DELIVERY</h1>
              <p>We're here to help</p>
            </div>
          </div>
        </div>
        </div>
      </section>
      <div className="pages_content">
        <div className="container">
          <div className="row">
            <div id="primary" className="content-area" style={{ float: 'left', width: '100%' }}>
              <main id="main" className="site-main" role="main">
                <div className="entry-content">
                  <div className="become_driver" style={{ padding: '20px', fontFamily: 'Arial, sans-serif', color: '#333' }}>
                    <h2 style={{ marginTop: '30px', marginBottom: '20px' }}>Same-Day Courier Collection & Delivery with Shypv</h2>
                    <p style={{ fontWeight: 'bold' }}>Need Something Delivered Urgently? We've Got You Covered.</p>
                    <p>
                      Whether you're an e-commerce business fulfilling online orders or a customer with a time-sensitive delivery,
                      our Time DIRECT same-day service ensures your parcel gets picked up and delivered across the UAE—fast, reliable, and 365 days a year, 24/7.
                    </p>
                    <div style={{ width: "100%", height: "2px", backgroundColor: "#b1b1b1", margin: "20px 0" }}></div>

                    <h4 style={{ marginTop: '30px', marginBottom: '20px' }}>How Same-Day Collection Works</h4>
                    <div style={{ listStyleType: 'disc', paddingLeft: '30px' }}>
                      <p>1. Place your order by <strong>11:30 AM (Saturday to Thursday)</strong> for same-day pickup and delivery.</p>
                      <ul style={{ listStyleType: 'disc', paddingLeft: '50px' }}>
                        <li>Orders placed after 11:30 AM will be delivered the next morning.</li>
                      </ul>
                      <p>2. Choose your preferred time slot for pickup.</p>
                      <ul style={{ listStyleType: 'disc', paddingLeft: '50px' }}>
                        <li>You'll need to be present at the selected address at the time of collection.</li>
                      </ul>
                      <p>3. Provide your Makani number to speed up the pickup and ensure accurate delivery.</p>
                      <p>4. Track your parcel live from pickup to delivery via our tracking portal.</p>
                      <p>5.  Receive instant notifications with tracking details (AWB and URL) as soon as your parcel is processed.</p>
                    </div>
                    <p style={{ fontStyle: "Italic", marginTop: "20px" }}>Minimum volume requirements may apply. Contact our customer support for more details.</p>
                    <div style={{ width: "100%", height: "2px", backgroundColor: "#b1b1b1", margin: "20px 0" }}></div>

                    <h4 style={{ marginTop: '30px', marginBottom: '20px' }}>Flexible Delivery Options</h4>
                    <ul style={{ listStyleType: 'disc', paddingLeft: '50px' }}>
                      <li><strong>Choose the vehicle size</strong> that best suits your parcel.</li><br />
                      <li><strong>Drop-off option available:</strong> Visit any Shypv access point to drop off your parcel at your convenience.</li><br />
                      <li><strong>Dedicated business support:</strong> Tools and systems designed to help e-commerce stores process orders quickly and efficiently.</li>
                    </ul>
                    <div style={{ width: "100%", height: "2px", backgroundColor: "#b1b1b1", margin: "20px 0" }}></div>

                    <h4 style={{ marginTop: '30px', marginBottom: '20px' }}>E-commerce Ready: Delight Your Customers</h4>
                    <p style={{ marginBottom: '20px' }}>Running an online store? Same-day delivery can give your business a competitive edge.</p>
                    <p style={{ marginBottom: '20px' }}>With Time DIRECT, you can:</p>
                    <ul style={{ listStyleType: 'disc', paddingLeft: '50px' }}>
                      <li>Offer same-day delivery within the UAE</li><br />
                      <li>Boost customer satisfaction with fast and reliable service</li><br />
                      <li>Increase repeat business by exceeding expectations</li><br />
                    </ul>
                    <p style={{ marginTop: '20px' }}>Need a quote? Email us at <a href="mailto:info@timexpress.ae" style={{ color: '#007BFF' }}>info@timexpress.ae</a> and let’s get you started.</p>
                    <div style={{ width: "100%", height: "2px", backgroundColor: "#b1b1b1", margin: "20px 0" }}></div>

                    <h4 style={{ marginTop: '30px', marginBottom: '20px' }}>Key Features of Time DIRECT Same-Day Delivery</h4>
                    <ul style={{ listStyleType: 'disc', paddingLeft: '50px' }}>
                      <li><strong>Priority Order Processing:</strong> Orders are processed immediately for faster fulfillment.</li><br />
                      <li><strong>Reliable Nationwide Network:</strong> We deliver across the UAE, including same-day within major cities.</li><br />
                      <li><strong>Real-Time Tracking:</strong> Monitor your parcel’s journey from pickup to delivery.</li><br />
                      <li><strong>Custom Pickup/Drop-Off:</strong> Home, office, or pickup point — whatever suits your needs.</li><br />
                      <li><strong>Extended Cut-Off Time:</strong> More time to place orders and still enjoy same-day delivery.</li><br />
                      <li><strong>24/7 Customer Support:</strong> Get help whenever you need it — we’re here for you.</li><br />
                    </ul>

                    <div style={{ width: "100%", height: "2px", backgroundColor: "#b1b1b1", margin: "20px 0" }}></div>

                    <h4 style={{ marginTop: '30px', marginBottom: '20px' }}>Why Offer Same-Day Delivery?</h4>
                    <ul className="benefits-list" style={{ listStyleType: 'disc', paddingLeft: '50px' }}>
                      <li>✅ Instant Gratification for Customers</li><br />
                      <li>✅ Higher Conversion Rates & Sales</li><br />
                      <li>✅ Stronger Brand Loyalty</li><br />
                      <li>✅ A Clear Competitive Advantage</li><br />
                      <li>✅ Streamlined Inventory Turnover</li><br />
                    </ul>
                    <div style={{ width: "100%", height: "2px", backgroundColor: "#b1b1b1", margin: "20px 0" }}></div>

                    <p>Experience the speed and reliability of Shypv Same-Day Delivery.</p>
                    <p>We’re committed to helping you deliver what matters, when it matters.</p>
                  </div>
                </div>
              </main>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
